<template>

    <div class="input-group | vn-input-text" :class="cssInputClass">

        <label :for="instanceId" v-html="field.title"></label>
        <input
            :name="key"
            :id="instanceId"
            :type="inputType"
            v-model="value"
            @focus="onFocus"
            @blur="onBlur"
        />

        <span class="error-message"  v-if="gotError"> {{ errorMessage }} </span>
    </div>

</template>

<script>

export default
{
    name: "InputText"
}

</script>

<script setup>

    import useFormInput                         from "../../composables/useFormInput";
    import {computed, nextTick, onMounted, ref} from 'vue';
    import { uniqueId }                         from 'lodash-es';

    let props = defineProps(["field"]);

    let { gotError, clearError, cssInputClass, errorMessage, value, key, exposed } = useFormInput(props);

    defineExpose(exposed);

    let instanceId = ref( null );


    let inputType = ref (getType());


    function getType ()
    {
        let type = props.field.text_type;

        if (!type)
        {
            return 'text';
        }

        if ([ 'password', 'email', 'number', 'tel', 'url', 'date', 'color' ].includes( type ))
        {
            return type;
        }

        if (type == 'currency')
        {
            return 'text';
        }

        return 'text';
    };

    function onFocus ()
    {
        if ([ 'currency' ].includes( props.field.text_type ))
        {
            inputType.value = "number";
            nextTick(() => {
                value.value = parseInt( value.value );
            });

        }
    }
    function onBlur ()
    {
        if ([ 'currency' ].includes( props.field.text_type ))
        {
            inputType.value = "text";

            nextTick(() => {

                let val = parseInt( value.value );

                if ( isNaN( val ) )
                {
                    val = 0;
                }

                value.value = `${val} $`;
            });

        }

        clearError();
    }

    onMounted(() => {
        if ( instanceId.value === null )
        {
            instanceId.value = uniqueId( props.field.key + '_' );
        }
    })

</script>
